export enum TimeFormat {
  /** Server date formats
   * (ServerFormatDateTime) Should be removed in the future!!!!! */
  ServerFormatDateTime = 'YYYY-MM-DD HH:mm', //hh - 12hours am/pm format, HH - 24hours format

  Date = 'YYYY-MM-DD',
  DateTime = 'YYYY-MM-DD HH:mm',
  FullDateTime = 'YYYY-MM-DD HH:mm:ss',
  FullDateTimeNoYear = 'DD/MM HH:mm',
  FullDateTimeMonthName = 'yyyy MMM D, HH:mm',
  Time = 'HH:mm',
  FullTime = 'HH:mm:ss',
  PartialDate = 'DD.MM',

  /** Calendar date formats */
  CalendarDate = 'DD/MM/YYYY',
  CalendarDateNoYear = 'DD/MM',
  CalendarYearMonth = 'MMMM yyyy',
  CalendarDateMonthDay = 'MM/dd/yyyy',
  CalendarWeekDayMonthYear = 'ddd MMMM DD yyyy',

  ImportDataDate = 'MM/DD/YYYY',

  DotsDate = 'D.M.YYYY',
  MonthDayYear = 'MMM d yyyy, HH:mm',
  MonthNamedDateTime = 'MMM DD HH:mm',
  MonthName = 'MMMM',
}

export enum DatePickerFormats {
  Date = 'yyyy-MM-dd',
  MonthDayYearNoHour = 'MMM dd yyyy',
  MFormDate = 'MM/dd/yyy',
  MFormDateTime = 'yyy/MM/dd h:mm',
  MonthDayYear = 'MMM d yyyy, HH:mm',
  GeneralDayMonthYear = 'dd/M/yyyy HH:mm',
  Time = 'HH:mm',
  TimePicker = 'HH:mm',
  GeneralDatePicker = 'DD/MM/YYYY',
}
